import { render } from "./Footer.vue?vue&type=template&id=d1688e34&scoped=true"
const script = {}

import "./Footer.vue?vue&type=style&index=0&id=d1688e34&scoped=true&lang=scss"

import exportComponent from "/Users/huangliu/Desktop/work/2024/develop/fdyun/ycx-website/node_modules/.store/vue-loader@16.8.3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d1688e34"]])

export default __exports__